// extracted by mini-css-extract-plugin
var _1 = "pilUb__betSelection";
var _2 = "pilUb__stats";
export { _1 as "betSelection", _2 as "stats" }
